import * as Slot from '@/ui/primitives/slot'
import type { SlottableTextProps, TextRef } from '@/ui/primitives/types'
import { cn } from '@/ui/utils'
import * as React from 'react'
import { Text as RNText } from 'react-native'

const TextClassContext = React.createContext<string | undefined>(undefined)

/**
 * Base UI class for text - use Typography/Header for branded specifics.
 *
 * This component is useful for generalized, customized text within the application
 * as it comes with context for passing down styles down to children to mimic CSS cascade
 * on mobile devices
 */
const ChildText = React.forwardRef<TextRef, SlottableTextProps>(
	({ className, asChild = false, ...props }, ref) => {
		const textClass = React.useContext(TextClassContext)
		const Component = asChild ? Slot.Text : RNText
		return (
			<Component
				className={cn(
					'text-body1 font-body text-ink web:select-text',
					textClass,
					className
				)}
				ref={ref}
				{...props}
			/>
		)
	}
)
ChildText.displayName = 'ChildText'

export { ChildText, TextClassContext }
